import Input from 'antd/es/input';
import List from 'antd/es/list';
import styled from 'styled-components';

import theme from '@theme';

export const SearchInput = styled(Input)`
  &&& {
    width: 100%;
    height: auto;
    caret-color: ${({ theme }) => theme.palette.primaryBrand};
    border: none;
    padding: 10px;
    font-size: 14px;

    @media (max-width: ${theme.breakPoint.WIDE_DESKTOP}) {
      width: 230px;
    }
    @media (max-width: ${theme.breakPoint.LARGE_1X}) {
      width: 100%;
    }
    &::placeholder {
      opacity: 1;
      font-size: 14px;
      font-weight: 600;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      color: ${({ theme }) => theme.palette.matterHorn};
    }
  }
`;

export const SearchResultListItem = styled(List.Item)`
  cursor: pointer;
  :hover {
    background-color: ${({ theme }) => theme.palette.primaryBrand};
  }
`;
